import { IWithApiData, ResourceType } from "Interfaces";
import { Serializer, Deserializer } from "jsonapi-serializer";

export function serializeJsonApiData<T>(type: ResourceType, item: T, id?: string) {
	const serializedData = new Serializer(type, {
		id: id ?? "",
		attributes: Array.isArray(item) ? Object.keys(item?.[0]) : Object.keys(item),
		keyForAttribute: "camelCase"
	});

	return serializedData.serialize(item);
}

export function deserializeJsonApiData<T>(json: IWithApiData): Promise<T> {
	return new Deserializer({ keyForAttribute: "camelCase" }).deserialize(json);
}
